import { ajax, jsonp } from '@ifeng-fe/ui_base';
import Grounds from 'ThreeTerminal_base/grounds';
const { GETLINKTYPE } = require('./client');

/* eslint-disable */
let apiBaseUrl = apiUrl;
const env = process.env.NODE_ENV;
/* eslint-enable */

if (typeof window === 'object' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

let userApi = 'https://user.iclient.ifeng.com';

// 清洗url，将前面的裁图前缀和参数已经协议头去掉。
const clear = url => {
    if (url.includes('d.ifengimg.com/')) {
        url = url.split('d.ifengimg.com/').pop();
        const paths = url.split('/');

        paths.shift();
        url = paths.join('/');
    }

    if (url.includes('http://')) {
        url = url.substring(7);
    }

    if (url.includes('https://')) {
        url = url.substring(8);
    }

    if (url.includes('//')) {
        url = url.substring(2);
    }

    return url;
};

/**
 *
 * @param {string} url 系统提供的图片地址
 * @param {number} width 图片裁切宽度
 * @param {number} height 图片裁切高度
 * @param {number} quality 图片裁切质量，最大值100，一般可以不填，不建议写100
 */
const formatImage = (url, width, height, quality) => {
    url = clear(url);

    const params = [];

    if (width) {
        params.push(`w${width}`);
    }

    if (height) {
        params.push(`h${height}`);
    }

    if (quality) {
        params.push(`q${quality}`);
    }

    return `//d.ifengimg.com/${params.join('_')}/${clear(url)}`;
};

/**
 * 校验勋章码
 * @param {String} code 勋章码
 */
export const checkMedalCode = async code => {
    return await Grounds.nativeRequest({
        url: `${userApi}/api_user_expv2/checkmedalcode`,
        type: 'post',
        postParams: {
            code,
        },
    });
};

// 热词搜索接口
export const getHotSearchWords = async () => {
    return await jsonp(`${apiBaseUrl}/sogouSearchHotword/getHotSearchWords`, {
        jsonpCallback: 'getHotSearchWords',
    });
};

/**
 * 获取举报选项接口
 */
export const getReportSelections = async type => {
    let apiUrl = 'https://topic.iclient.ifeng.com/api/reason/';

    switch (type) {
        case 'artical':
            apiUrl += 'reasonlist';
            break;
        case 'user':
            apiUrl += 'userReasonList';
            break;
        case 'comment':
            apiUrl += 'commentreasonlist';
            break;
    }

    const res = await jsonp(apiUrl, {
        jsonpCallback: 'reasonlist',
    });

    return res.reasonlist;
};

/**
 * 举报接口
 */
export const report = async ({ type, data }) => {
    let apiUrl = 'https://topic.iclient.ifeng.com/api/report/';

    switch (type) {
        case 'artical':
            apiUrl += 'addReport';
            break;
        case 'user':
            apiUrl += 'addUserReport';
            break;
        case 'comment':
            apiUrl += 'addCommentReport';
            break;
    }

    const search = window.location.search.replace('?', '').split('&');
    const params = {};

    search.forEach(item => {
        const arr = item.split('=');
        let key = arr[0];

        if (/docid/i.test(item)) key = 'documentid';
        if (/loginid/i.test(item)) key = 'guid';
        if (/commentid/i.test(item)) key = 'commentid';

        params[key] = /title|nickname|commentContent/i.test(key) ? decodeURIComponent(arr[1]) : arr[1];
    });

    let formData = Object.assign(params, {
        questionid: Object.keys(data).join(','),
    });
    const proid = (window.grounds && window.grounds.getDeviceInfo().getProid()) || 'ifengnews';

    formData = {
        proid,
        ...formData
    };
    
    if (data['other']) formData.other = data['other'].content;

    return await jsonp(apiUrl, {
        data: formData,
    });
};

/**
 * 获取火力无限列表数据
 * @param pageSize
 * @param pageNum
 * @returns {Promise<*>}
 */
export const getHuoliwuxianList = async (key, pageNum = 1, pageSize = 6) => {
    const listData = await jsonp(
        `${apiBaseUrl}/huoliwuxian/huoliwuxianList/${key}/${pageNum}/${pageSize}/getHuoliwuxianList`,
        {
            jsonpCallback: 'getHuoliwuxianList',
            cache: 120,
        },
    );

    if (!listData.data) {
        return '';
    }

    const imgSize = {
        width: 230,
        height: 164,
    };

    if (key === '75221') {
        imgSize.width = 342;
        imgSize.height = 250;
    }

    const listDataByPage = listData.data;

    const data = listDataByPage.map(item => ({
        type: item.type || '',
        guid: item.guid || '',
        commentUrl: item.commentUrl || '',
        link: GETLINKTYPE(item),
        title: item.title || '',
        src:
            (item.thumbnails &&
                item.thumbnails.image &&
                item.thumbnails.image[0].url &&
                formatImage(item.thumbnails.image[0].url, imgSize.width, imgSize.height)) ||
            (item.thumbnail && formatImage(item.thumbnail, imgSize.width, imgSize.height)) ||
            '',
        url: item.url || '',
    }));

    if (data && data.length > 0) {
        return data;
    } else {
        return [];
    }
};
